import { Filter } from '@cubejs-client/core';

import { useModuleContext } from '~/components/ModuleContextProvider';

import { OrderVolumeCommodityGroupWidget } from './OrderVolumeCommodityGroupWidget';

export const SupplierOrderVolumeCommodityGroupWidget = () => {
  const { entityId } = useModuleContext();

  const cube = 'CommodityGroupRoot';

  const filters: Filter[] = [
    {
      member: `${cube}.supplierId`,
      operator: 'equals',
      values: [entityId],
    },
  ];

  return (
    <OrderVolumeCommodityGroupWidget
      config={{
        cube,
        filters,
      }}
    />
  );
};
